const data = {
  counterText: 'Slechts enkele plaatsen beschikbaar',
  loading: 'Pagina laadt',
  next: 'Verder',
  previous: 'Vorig',
  smCounterText: 'Beperkt aantal plaatsen beschikbaar!',
};

export default data;
